export default "__VITE_ASSET__e3f2da61__"